const GOOGLE_BORDER = '#dadce0';
const GOOGLE_COLOR = '#3c4043';

export const buttonContainerStyles = {
  marginBottom: '32px',
  height: '40px',
  border: GOOGLE_BORDER,
  borderStyle: 'solid',
  borderWidth: 'thin',
  borderRadius: '3px',
  color: GOOGLE_COLOR,
  paddingTop: '2px',
  sx: {
    svg: {
      verticalAlign: 'initial',
    },
    text: {
      fontSize: '13px',
    },
  },
};
